import { IconProps } from '@/shared/lib/types'
import { getStatusColors } from '@/shared/utils/getStatusColors'

type Props = IconProps & {
  transaction: 'withdrawal' | 'deposit'
  type: 'sign' | 'arrow'
}

export const FinanceIcon = ({ transaction, status, type }: Props) => {
  const { fillColor, strokeColor } = getStatusColors(status)

  if (transaction === 'withdrawal' && type === 'sign') {
    return (
      <svg
        width="41"
        height="40"
        viewBox="0 0 41 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="0.5" width="40" height="40" rx="20" fill={fillColor} />
        <path
          d="M10.5 20C10.5 25.5294 14.9706 30 20.5 30C26.0294 30 30.5 25.5294 30.5 20C30.5 14.4706 26.0294 10 20.5 10C14.9706 10 10.5 14.4706 10.5 20Z"
          stroke={strokeColor}
          strokeWidth="1.5"
        />
        <path
          d="M16.5 19.25H24.5C24.9142 19.25 25.25 19.5858 25.25 20C25.25 20.4142 24.9142 20.75 24.5 20.75H16.5C16.0858 20.75 15.75 20.4142 15.75 20C15.75 19.5858 16.0858 19.25 16.5 19.25Z"
          fill={strokeColor}
          stroke={strokeColor}
          strokeWidth="0.5"
        />
      </svg>
    )
  } else if (transaction === 'deposit' && type === 'sign') {
    return (
      <svg
        width="41"
        height="40"
        viewBox="0 0 41 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="0.5" width="40" height="40" rx="20" fill={fillColor} />
        <path
          d="M10.5 20C10.5 25.5294 14.9706 30 20.5 30C26.0294 30 30.5 25.5294 30.5 20C30.5 14.4706 26.0294 10 20.5 10C14.9706 10 10.5 14.4706 10.5 20Z"
          stroke={strokeColor}
          strokeWidth="1.5"
        />
        <path
          d="M16.5 19.25H24.5C24.9142 19.25 25.25 19.5858 25.25 20C25.25 20.4142 24.9142 20.75 24.5 20.75H16.5C16.0858 20.75 15.75 20.4142 15.75 20C15.75 19.5858 16.0858 19.25 16.5 19.25Z"
          fill={strokeColor}
          stroke={strokeColor}
          strokeWidth="0.5"
        />
        <path
          d="M20.5 15.25C20.9142 15.25 21.25 15.5858 21.25 16V24C21.25 24.4142 20.9142 24.75 20.5 24.75C20.0858 24.75 19.75 24.4142 19.75 24V16C19.75 15.5858 20.0858 15.25 20.5 15.25Z"
          fill={strokeColor}
          stroke={strokeColor}
          strokeWidth="0.5"
        />
      </svg>
    )
  } else if (transaction === 'deposit' && type === 'arrow') {
    return (
      <svg
        width="41"
        height="40"
        viewBox="0 0 41 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="0.5" width="40" height="40" rx="20" fill={fillColor} />
        <path
          d="M10.5 20C10.5 25.5294 14.9706 30 20.5 30C26.0294 30 30.5 25.5294 30.5 20C30.5 14.4706 26.0294 10 20.5 10C14.9706 10 10.5 14.4706 10.5 20Z"
          stroke={strokeColor}
          strokeWidth="1.5"
        />
        <path
          d="M20.3701 23.4746C20.4527 23.508 20.5463 23.508 20.6289 23.4746L20.6377 23.4717C20.6583 23.4638 20.6779 23.4538 20.6963 23.4424L20.748 23.4023L24.9033 19.3174L24.9043 19.3164C24.935 19.2865 24.9594 19.251 24.9756 19.2129C24.9918 19.1747 25 19.1336 25 19.0928C25 19.0519 24.9918 19.0108 24.9756 18.9727C24.9594 18.9346 24.935 18.8991 24.9043 18.8691L24.9014 18.8672C24.8708 18.8369 24.8341 18.8118 24.793 18.7949C24.7519 18.7781 24.7071 18.7695 24.6621 18.7695C24.6173 18.7696 24.5732 18.7782 24.5322 18.7949C24.4911 18.8118 24.4534 18.8369 24.4229 18.8672L21.6826 21.5684L20.832 22.4082V15.8184C20.832 15.7368 20.7987 15.657 20.7373 15.5967C20.6756 15.536 20.59 15.5 20.499 15.5C20.4082 15.5001 20.3224 15.536 20.2607 15.5967C20.1995 15.657 20.167 15.7369 20.167 15.8184V22.4082L19.3154 21.5684L16.5771 18.8682C16.5148 18.8068 16.4278 18.7705 16.3359 18.7705C16.2442 18.7705 16.1581 18.8069 16.0957 18.8682C16.0336 18.9292 16 19.0102 16 19.0928C16 19.1338 16.0083 19.1745 16.0244 19.2129C16.0406 19.2513 16.0649 19.2871 16.0957 19.3174L20.251 23.4023C20.2823 23.4318 20.3198 23.4559 20.3613 23.4717L20.3701 23.4746Z"
          fill={strokeColor}
          stroke={strokeColor}
        />
      </svg>
    )
  } else if (transaction === 'withdrawal' && type === 'arrow') {
    return (
      <svg
        width="41"
        height="40"
        viewBox="0 0 41 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="0.5" width="40" height="40" rx="20" fill={fillColor} />
        <path
          d="M10.5 20C10.5 25.5294 14.9706 30 20.5 30C26.0294 30 30.5 25.5294 30.5 20C30.5 14.4706 26.0294 10 20.5 10C14.9706 10 10.5 14.4706 10.5 20Z"
          stroke={strokeColor}
          strokeWidth="1.5"
        />
        <path
          d="M20.3701 15.5254C20.4527 15.492 20.5463 15.492 20.6289 15.5254L20.6377 15.5283C20.6583 15.5362 20.6779 15.5462 20.6963 15.5576L20.748 15.5977L24.9033 19.6826L24.9043 19.6836C24.935 19.7135 24.9594 19.749 24.9756 19.7871C24.9918 19.8253 25 19.8664 25 19.9072C25 19.9481 24.9918 19.9892 24.9756 20.0273C24.9594 20.0654 24.935 20.1009 24.9043 20.1309L24.9014 20.1328C24.8708 20.1631 24.8341 20.1882 24.793 20.2051C24.7519 20.2219 24.7071 20.2305 24.6621 20.2305C24.6173 20.2304 24.5732 20.2218 24.5322 20.2051C24.4911 20.1882 24.4534 20.1631 24.4229 20.1328L21.6826 17.4316L20.832 16.5918V23.1816C20.832 23.2632 20.7987 23.343 20.7373 23.4033C20.6756 23.464 20.59 23.5 20.499 23.5C20.4082 23.4999 20.3224 23.464 20.2607 23.4033C20.1995 23.343 20.167 23.2631 20.167 23.1816V16.5918L19.3154 17.4316L16.5771 20.1318C16.5148 20.1932 16.4278 20.2295 16.3359 20.2295C16.2442 20.2295 16.1581 20.1931 16.0957 20.1318C16.0336 20.0708 16 19.9898 16 19.9072C16 19.8662 16.0083 19.8255 16.0244 19.7871C16.0406 19.7487 16.0649 19.7129 16.0957 19.6826L20.251 15.5977C20.2823 15.5682 20.3198 15.5441 20.3613 15.5283L20.3701 15.5254Z"
          fill={strokeColor}
          stroke="#0B8D51"
        />
      </svg>
    )
  }
}
